const FUNCTIONS_BASE_URL = "https://us-central1-manucalc-1d2b5.cloudfunctions.net";

const postWithAuth = async (path, user, body = {}) => {
  if (!user?.getIdToken) throw new Error("A valid login is required.");
  const token = await user.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Founder program request failed.");
  }
  return data;
};

export const claimFounderAccess = (user) =>
  postWithAuth("claimFounderAccess", user);

export const updateFounderStatus = (user, payload) =>
  postWithAuth("updateFounderStatus", user, payload);

export const getFounderProgramStatus = async () => {
  const response = await fetch(`${FUNCTIONS_BASE_URL}/getFounderProgramStatus`, {
    method: "GET",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Founder program status could not be loaded.");
  }
  return data;
};
